import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { GetServerSideProps } from 'next';
import { getLocale } from '@hub/libs/constants';
import { getNodeContactProp } from '@hub/libs/node-contact.helper';
import { getInitialLayoutData, type LayoutData } from '@hub/page-helpers/getInitialLayoutData';
import { BEARINGHUB_NODEID_OVERWRITES } from '@hub/bearing-hub/common/constants';
import type { FreeFormHubResultProps } from '@hub/free-form-hub/free-form-hub-result/FreeFormHubResult';
import { FreeFormHubResult } from '@hub/free-form-hub/free-form-hub-result/FreeFormHubResult';
import { LoaderProvider } from '@hub/free-form-hub/common/loader/LoaderProvider';
import { getFfhLanguageAlternates, getServerSideTranslations } from '@hub/libs/i18n.helper';

export interface FreeFormHubProps {
  layout: LayoutData;
}

export const getServerSideProps: GetServerSideProps<FreeFormHubProps> = async context => {
  const { query } = context;

  const locale = getLocale(context);
  const nodeContactId = BEARINGHUB_NODEID_OVERWRITES.FFH; // FIXME: use real node contact ID
  const contact = await getNodeContactProp(nodeContactId, locale);
  const languageAlternates = getFfhLanguageAlternates(query as Record<string, string>);
  const layoutData = await getInitialLayoutData(locale, languageAlternates);

  return {
    props: {
      layout: layoutData,
      languageAlternates,
      contact,
      ...(await getServerSideTranslations(serverSideTranslations, locale, [
        'bearing-hub/bearingHub',
        'free-form-hub/freeFormHub',
        'free-form-hub/freeFormHubDetails',
        'free-form-hub/chemicals',
        'free-form-hub/materials',
        'free-form-hub/freeFormHubCommon',
        'free-form-hub/lifeTime',
        'layout/marketingBanner',
        'layout/localeSelection',
        'layout/contactPersonBox',
        'layout/breadcrumb',
        'layout/header',
        'product/buyBox',
        'category/productFilter',
        'category/categoryPage',
        'toast/toast',
        'free-form-hub/freeFormHubUpload',
      ])),
    } as FreeFormHubProps,
  };
};

const FreeFormHubPage = ({ layout, contact }: FreeFormHubResultProps) => (
  <LoaderProvider>
    <FreeFormHubResult layout={layout} contact={contact} />
  </LoaderProvider>
);

export default FreeFormHubPage;
